enum EventMediaType {
    Phone = 'phone',
    Mobile = 'mobile',
    VideoConferencing = 'video-conferencing',
    FaceToFace = 'face-to-face',
}

export default EventMediaType;
